export const config = {
  api: {
    baseUrl: process.env.REACT_APP_API_BASE_URL || 'http://localhost:8000' // Fallback to localhost if env var is not set
  }
}; 